import { Field } from 'formik';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { Check } from 'lucide-react';

interface OptionCorrectToggleProps {
  index: number;
  isCorrect: boolean;
  setFieldValue: (field: string, value: any) => void;
  isEditable: boolean;
}

export function OptionCorrectToggle({
  index,
  isCorrect,
  setFieldValue,
  isEditable,
}: OptionCorrectToggleProps) {
  const handleToggleCorrect = (checked: boolean) => {
    // Simply toggle the current option without affecting others
    // This allows multiple options to be marked as correct
    setFieldValue(`options.${index}.is_correct`, checked);
  };

  return (
    <div className="flex items-center gap-6">
      <div className="flex items-center gap-2">
        <Field name={`options.${index}.is_correct`}>
          {({ field }: any) => (
            <Switch
              data-test-id={`question-option-${index}-is_correct-switch`}
              checked={field.value}
              onCheckedChange={handleToggleCorrect}
              disabled={!isEditable}
            />
          )}
        </Field>
        <Label>Correct Answer</Label>
        {isCorrect && <Check className="h-4 w-4 text-green-600" />}
      </div>
    </div>
  );
}
